import React from "react";
import { SearchChatsList } from "../../../../model/branch/BranchChatsModel";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import NoData from "../../../../widget/common/ui/NoData";
import { TextBlock } from "../../../../widget/common/ui/Text";

const BranchDeptChatsList = (props: {
  chatList: Array<SearchChatsList> | null;
  type?: number | undefined;
  onClickDeptChat: (detail: SearchChatsList) => void;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <>
      {props.chatList == null ? (
        <Center>{Loader.normal()}</Center>
      ) : props.chatList.length === 0 ? (
        <Center>
          <NoData />
        </Center>
      ) : (
        <Listing>
          {(props.chatList ?? []).map((chat, key) => (
            <ListItem key={key}>
              <div
                role="button"
                className={type === 1 ? `py-1` : `py-2`}
                onClick={() => props.onClickDeptChat(chat)}
              >
                <Div fontName="book" color="theme-label" fontSize="16_17">
                  <TextBlock>{chat.chat_title}</TextBlock>
                </Div>
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default BranchDeptChatsList;
